<button type="button"
        (click)="download()"
        placement="left" *ngIf="object.status === completed"
        [ngbTooltip]="labelTooltip"
        class="btn list-tools">
  <app-progressbar *ngIf="showSpinner"></app-progressbar>
  <fa-icon [icon]="faCloudDownloadAlt"></fa-icon>
</button>
